import { isRoam, roamRoot } from 'src/config'

export default ({ router }) => {
  if (!isRoam) return

  /**
   * Set routes
   */
  const routeData = {
    path: roamRoot,
    component: () => import('src/modules/roam/layouts/RoamLayout.vue')
  }

  routeData.children = [
    {
      name: 'roam:root',
      path: '',
      redirect: { name: 'roam:concierge' }
    },
    {
      name: 'roam:concierge',
      path: 'concierge',
      component: () => import('src/modules/roam/pages/RoamConcierge')
    },
    {
      name: 'roam:tickets',
      path: 'tickets',
      component: () => import('src/modules/roam/pages/RoamTickets')
    },
    {
      name: 'roam:showings',
      path: 'showings',
      component: () => import('src/modules/roam/pages/RoamShowings')
    }
  ]

  router.addRoute(routeData)

  if (isRoam) {
    router.addRoute({ name: 'app:root', redirect: { name: 'roam:root' } })
  }
}
